import React, { FunctionComponent } from "react"
import dayjs from "dayjs"
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap"
import timeMachine from "src/utilities/TimeMachine/timeMachine"
import taskManagerUtils from "../TaskManagerUtils/TaskManagerUtils"
import "./TaskManagerTable.css"

interface Props {
    tasks: Array<number>
    activeView: { id: number, active: boolean, title: string, endpoint: string, order: number }
    sortMap: { direction: "asc" | "desc" | string, type: "date" | "text" | string, key: string }
    timeFormat: string
    timeZoneOffset: number
    manageParentState: Function
}

const TaskManagerTable: FunctionComponent<Props> = (props) => {

    const tasks = props.tasks

    //hiddenTableItems is array of ids from the viewTypes array in TaskManager.tsx.  Add the id of the viewType to table the item you want to hide
    const tableItems = [
        { title: "Name", popoverText: "Task name", key: "Name", order: 1, hashTableItemIndex: 3, hiddenTableItems: [] },
        { title: "Created", popoverText: "Created date", key: "CreatedDateUTC", order: 2, hashTableItemIndex: 4, isDate: true, hiddenTableItems: [3] },
        { title: "Completed", popoverText: "Completed date", key: "CompletedDateUTC", order: 4, hashTableItemIndex: 4, isDate: true, hiddenTableItems: [2] },
        { title: "Due", popoverText: "Due date", key: "DueDateUTC", order: 3, hashTableItemIndex: 4, isDate: true, hiddenTableItems: [3] },
        { title: "+/-", popoverText: "Punctuality", key: "Punctuality", order: 5, hashTableItemIndex: 4, timeCalc: { key1: "DueDateUTC", key2: "CompletedDateUTC" }, hiddenTableItems: [2, 3], punctuality: true }
    ].sort(({ order: a }, { order: b }) => a - b)

    const filterTableItems = (id: number) => {
        let filteredItems = []
        for (let i = 0; i < tableItems.length; i++) {
            const tableItem = tableItems[i]
            //@ts-ignore
            if (tableItem.hiddenTableItems.indexOf(id) < 0) {
                filteredItems.push(tableItem)
            }
        }
        return filteredItems
    }

    const filteredTableItems = filterTableItems(props.activeView.id)

    const renderTimeDiscrepancyHTML = (a: string, b: string) => {
        const difference = taskManagerUtils.getTimeDiscrepancy(a, b, props.timeZoneOffset)
        const late = difference < 0
        return (<div className={`TaskManagerTableTimeTimeDiscrepancyItem ${late ? "TaskManagerTableTimeTimeDiscrepancyItemLate" : "TaskManagerTableTimeTimeDiscrepancyItemOnTime"}`}>
            <span className="material-icons">task_alt</span>
            <p>{timeMachine.millisecondsToDaysHoursMinutes(difference)}</p>
        </div>)
    }

    const TaskManagerTableTooltip = (text: string) => (
        <Tooltip id="task-mananger-table-tooltip">
            {text}
        </Tooltip>
    )

    // //console.log("TaskManagerTable tasks", tasks)

    return (
        <div className="TaskManagerTable">
            {tasks.length > 0 && <Table striped bordered hover>
                <thead>
                    <tr id="task-mananger-table-header">
                        {filteredTableItems.map((item, i) =>
                            <th id={`task-mananger-table-header-th-${item.key.toLowerCase()}`} key={`task-mananger-table-header-th-${i}`}>
                                <div className="TaskManagerTableHeaderItem">
                                    <div className="TaskManagerTableHeaderItemText">
                                        {item.title}
                                    </div>
                                    <OverlayTrigger placement="auto" overlay={TaskManagerTableTooltip(`Sort by ${item.popoverText}, order ${props.sortMap.direction === "asc" ? "desc" : "asc"}`)}>
                                        <div className={`TaskManagerTableHeaderItemControls ${(props.sortMap.key === item.key && props.sortMap.direction === "asc") ? "TaskManagerTableHeaderItemControlsAsc" : "TaskManagerTableHeaderItemControlsDesc"} ${props.sortMap.key === item.key ? "TaskManagerTableHeaderItemControlsActive" : "TaskManagerTableHeaderItemControlsNotActive"}`}
                                            id={`task-manager-table-item-controls-${i}`}
                                            onClick={() => {
                                                let sortMap = props.sortMap
                                                sortMap.direction = sortMap.direction === "asc" ? "desc" : "asc"
                                                sortMap.key = item.key
                                                sortMap.type = item.isDate ? "date" : item.punctuality ? "number" : "text"
                                                props.manageParentState([{ key: "sortMap", value: sortMap }])
                                            }}
                                        >
                                            <span className="material-icons">sort</span>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </th>)}
                    </tr>
                </thead>
                <tbody>
                    {tasks.map(taskId => {
                        const task = taskManagerUtils.lookupItem(`${taskId}`)
                        return (
                            <tr id={`task-manager-table-tr-${taskId}`} key={`task-manager-table-tr-${taskId}`}>
                                {filteredTableItems.map((tableDataItem, j) =>
                                    <td id={`task-manager-table-td-${tableDataItem.key.toLowerCase()}`} key={`task-manager-table-td-${j}`}
                                        onClick={() => props.manageParentState([{ key: "taskToView", value: task[4] }])}>
                                        <div className="TaskManagerTableTDWrapper">
                                            {/*@ts-ignore*/
                                                typeof task[tableDataItem.hashTableItemIndex] === "string" ? task[tableDataItem.hashTableItemIndex]
                                                    /*@ts-ignore*/
                                                    : tableDataItem.isDate ? dayjs(task[tableDataItem.hashTableItemIndex][tableDataItem.key]).utc("z").local().utcOffset(props.timeZoneOffset).format(props.timeFormat)
                                                        /*@ts-ignore*/
                                                        : tableDataItem.timeCalc ? renderTimeDiscrepancyHTML(task[tableDataItem.hashTableItemIndex][tableDataItem.timeCalc.key1], task[tableDataItem.hashTableItemIndex][tableDataItem.timeCalc.key2])
                                                            /*@ts-ignore*/
                                                            : task[tableDataItem.hashTableItemIndex][tableDataItem.key]}
                                        </div>
                                    </td>)}
                            </tr>)
                    })}
                </tbody>
            </Table>}
        </div >
    )
}

export default TaskManagerTable